import Dialog from "@/components/Dialog";
import Button from "@/components/Button";
import classNames from "classnames";

interface RemoveStaffMemberDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  staffName?: string;
  roleTitle?: string;
}

export function RemoveStaffMemberDialog({
  open,
  onClose,
  onConfirm,
  isLoading = false,
  staffName = "this staff member",
  roleTitle
}: RemoveStaffMemberDialogProps) {
  return (
    <Dialog
      open={open}
      onClosed={onClose}
      headline="Remove Staff Member"
      actions={
        <>
          <Button variant="text" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            theme="error"
            icon={isLoading ? "progress_activity" : "delete"}
            iconClassName={classNames(isLoading && "animate-spin w-6 h-6 !block")}
            trailingIcon={false}
          >
            Remove
          </Button>
        </>
      }
    >
      <p>
        Are you sure you want to remove {staffName}
        {roleTitle ? ` as ${roleTitle}` : ""} from this university? They will stop receiving university notification
        emails.
      </p>
    </Dialog>
  );
}
